import produce from "immer";

import { IPageViewState } from "../Contracts";
import { PageActionsType, PageActionTypes } from "./PageActions";

import * as Constants from "../../../../common/Constants";

export function pageReducer(state: IPageViewState, action: PageActionsType): IPageViewState {
    return produce(state || ({} as IPageViewState), draft => {
        switch (action.type) {
            case PageActionTypes.InitPage: {
                draft.messages = {};
                draft.modals = {};
                draft.panels = {};
                draft.theme = Constants.Themes.Default;
                draft.viewOptions = {};
                break;
            }
            case PageActionTypes.UpdatePanels: {
                draft.panels = { ...state.panels, ...action.payload };
                break;
            }
            case PageActionTypes.UpdateModals: {
                draft.modals = { ...state.modals, ...action.payload };
                break;
            }

            case PageActionTypes.SetTheme: {
                draft.theme = action.payload;
                break;
            }
            case PageActionTypes.UpdateMessages: {
                draft.messages = { ...draft.messages, ...action.payload };
                break;
            }
            default:
                draft = state;
        }
    });
}
